import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { showToast } from "../../ToastNotification";

export const useMatchCards = (matchId) => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = useSelector((state) => state.user.token);

  const fetchCards = async () => {
    try {
      setLoading(true);

      // 🔹 Log para validar qué se está enviando
      console.log("🔹 fetchCards -> matchId:", matchId);

      const res = await fetch(
        `https://server-postgre.vercel.app/api/matches/${matchId}/cards`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // 🔹 Log para validar el estado de la respuesta
      console.log("🔹 fetchCards -> res.ok:", res.ok, "status:", res.status);

      if (!res.ok) throw new Error("Error al obtener tarjetas");

      const data = await res.json();

      // 🔹 Log para ver los datos recibidos
      console.log("🔹 fetchCards -> data:", data);

      setCards(data);
    } catch (err) {
      console.error("❌ fetchCards -> error:", err);
      setError(err.message);
      showToast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const addCard = async (cardData) => {
    try {
      const res = await fetch("https://server-postgre.vercel.app/api/cards", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cardData),
      });
      if (!res.ok) throw new Error("Error al agregar tarjeta");
      const newCard = await res.json();
      setCards((prev) => [...prev, newCard]);
      showToast.success("Tarjeta agregada");
      return newCard;
    } catch (err) {
      showToast.error(err.message);
      throw err;
    }
  };

  const updateCard = async (id, cardData) => {
    try {
      const res = await fetch(
        `https://server-postgre.vercel.app/api/cards/${id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cardData),
        }
      );
      if (!res.ok) throw new Error("Error al actualizar tarjeta");
      const updated = await res.json();
      setCards((prev) => prev.map((c) => (c.id === id ? updated : c)));
      showToast.success("Tarjeta actualizada");
      return updated;
    } catch (err) {
      showToast.error(err.message);
      throw err;
    }
  };

  const deleteCard = async (id) => {
    try {
      const res = await fetch(
        `https://server-postgre.vercel.app/api/cards/${id}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!res.ok) throw new Error("Error al eliminar tarjeta");
      setCards((prev) => prev.filter((c) => c.id !== id));
      showToast.success("Tarjeta eliminada");
    } catch (err) {
      showToast.error(err.message);
      throw err;
    }
  };

  useEffect(() => {
    if (matchId) fetchCards();
  }, [matchId]);

  return {
    cards,
    loading,
    error,
    addCard,
    updateCard,
    deleteCard,
    refresh: fetchCards,
  };
};
